// Form4 Types

export interface Section {
  id: string;
  pageComponentId: string;
  componentId?: string;
  type: string;
  variant: string;
  title: string;
  order: number;
  data?: any;
}

export interface VariantDetails {
  id: string;
  name: string;
  description: string;
  componentFields: any[];
  /** Tabbed segment workbench — each group has its own field formatter list */
  segmentDefinitions?: Array<{ id: string; label: string; fields: any[] }>;
  /** Shown above segment tabs (e.g. global lead banner fields) */
  globalSegmentFields?: any[];
  /** Optional: compact mobile strip CTA (university lead drop + page only; omit for lead popup variant 6) */
  globalLeadDropMobileStripFields?: any[];
  /** Explanation above mobile-strip fields; defaults to bundled copy when strip fields are shown */
  globalLeadDropMobileStripHelpText?: string;
  metadataFields?: any[];
  showTable: boolean;
  setAction: any;
  selector: (state: any) => any;
  updateMethod?: (id: number, data: any) => Promise<any>;
  constants: Record<string, string>;
}

export interface FormProps {
  selectedSection: Section;
  onSave: (updatedSection: Section) => void;
  pageId?: string;
  pageComponentId?: string;
  variantDetails?: VariantDetails;
}

export interface FormState {
  componentFields: Record<string, any>;
  componentFieldErrors: Record<string, boolean>;
  componentFieldMessages: Record<string, string>;
  isLoading: boolean;
}

